__turbopack_context__.v({
  "content": "SnackbarContent-module-scss-module__iFyKdq__content",
  "cta-container": "SnackbarContent-module-scss-module__iFyKdq__cta-container",
  "message": "SnackbarContent-module-scss-module__iFyKdq__message",
});
